<template>
  <div class="client-container">
    <div :style="{ overflow: 'hidden' }">
      <bread-crumb :style="{ float: 'left' }" />
	  
      <a-button
        type="primary"
        shape="round"
        icon="plus"
        :style="{ float: 'right', marginTop: '19px' }"
        @click="editAndAdd"
      >
        新增学术资料
      </a-button>
	  <a-select placeholder="请选择合作企业" v-model="company_id"  style="width: 225px; margin:19px 23px 0;float:right;border-radius: 15px;"  @change="value => onChangecompany(value)">
	  					<a-select-option v-for="item in companyData" :key="item.id" :value="item.id">
	  						{{ item.companyInfo.qichacha_name }}
	  					</a-select-option>
	  				</a-select>
    </div>
    <div class="global-table-container">
      <a-table
        :columns="columns"
        :data-source="tableData"
        :loading="loading"
        :row-key="record => record.id"
        :pagination="{
          pageSize,
          total,
          current,
          showTotal: total => `共${total}条`,
        }"
        @change="changePage"
      >
        <template
          slot="attach_doc_info_list"
          slot-scope="text,record"
        >
          <a
            v-for="(item,index) in record.attach_doc_info_list"
            :key="item.id"
            :href="item.url"
			target="_blank"
          >{{ item.name }}{{ index===record.attach_doc_info_list.length-1?'':'、' }}</a>
        </template>
        <template
          slot="operation"
          slot-scope="text, record"
        >
          <a
            href="javascript:;"
            @click="() => editAndAdd(record)"
          >编辑</a>
          <a-divider type="vertical" />
          <popconfirm-button
            :text="record.data.status===1?'禁用':'启用'"
            :alert-title="record.data.status===1?'确定禁用？':'确定启用？'"
            @onDelete="() => onConfirm(record)"
          />
          <a-divider type="vertical" />
          <popconfirm-button
            text="删除"
            alert-title="确定删除？"
            @onDelete="() => onDelete(record)"
          />
        </template>
      </a-table>
    </div>
	<a-modal class="client-modal-wrapper" width="702px" :mask-closable="false" @cancel="onCancelImg" :visible="isVisibleImg" :footer="null">
		<div style="text-align: center;">
			<img :src="url" >
		</div>
		<form-button
		:showMsg="false"
		submitText="确定"
		  @onCancel="onCancelImg"
		  @onSubmit="onCancelImg"
		  
		/>
	</a-modal>
    <product-modal
      ref="formRef"
      :is-visible-brand="isVisibleBrand"
      :company-is-disabled="companyIsDisabled"
      :title="title"
	  :limit="limit"
	  :editType="editType"
      @onCancel="onCancel"
    >
      <form-button
        :btn-is-loading="btnIsLoading"
        @onCancel="onCancel"
        @onSubmit="onSubmit"
      />
    </product-modal>
  </div>
</template>
<script>
import { companyColumns, serviceColumns } from './data/index';
import { getType, getCompany } from './utils/dealTable';
import ProductModal from './modal/index.vue';
export default {
  components: { ProductModal },
  data() {
    return {
		  isVisibleImg:false,
		  companyData: [],
		  url:'',
      btnIsLoading: false,
	    editType:false,
      selectData: [],
      columns: [],
      tableData: [],
      pageSize: 10,
      current: 1,
      total: 0,
	    limit:true,
      loading: true,
      isVisibleBrand: false,
      title: '',
      brandId: undefined,
      companyIsDisabled: false,
	    company_id:''
    };
  },
  async mounted() {
    if (this.$store.state.user.role === 1) {
      this.columns = serviceColumns;
    } else {
      this.columns = companyColumns;
    }
    // 获取合作企业
    await this.getCompanyList();
    // 获取资料类型
    await this.getSystemConfig();
    // 获取表格数据
   
  },
  methods: {
	  prew(url){
		  this.isVisibleImg=true;
		  this.url=url
	  },
	  onCancelImg(){
		  this.isVisibleImg=false;
	  },
    // 获取合作企业
    async getCompanyList() {
      let result = await this.$http.post('/Company/getCooperationCompanyList');
      if (result.data.status === 1) {
        this.companyData = result.data.data.data_list;
		    this.company_id=this.companyData[0].id
		    this.getTableData({ page: this.current, pageSize: this.pageSize,cooperation_company_id: this.company_id });
      }
    },
    // 获取资料类型
    async getSystemConfig() {
      let result = await this.$http.post('/system/getConfigs');
      if (result.data.status === 1) {
        this.academic_material = result.data.data.academic_material;
      }
    },
    // 获取表格数据
    async getTableData(params) {
      this.loading = true;
      let result = await this.$http.post('/AcademicMaterial/getList', params);
      if (result.data.status === 1) {
        this.loading = false;
        this.total = result.data.data.count;
        let data = result.data.data.data_list;
        let temp = [];
        data.forEach((item) => {
          let obj = {
            id: item.id,
            company_id: item.company.companyInfo.qichacha_name,
            name: item.name,
            scene: item.scene,
            type: getType(this.academic_material, item.type),
            attach_doc_info_list: item.attach_doc_info_list,
			      product_info_title: item.product_info.title,
            summary: item.summary.length>50?item.summary.substring(0, 50)+'...':item.summary,
            status: item.status,
            data: item,
          };
          temp.push(obj);
        });
        this.tableData = temp;
        console.log('TCL: getTableData -> this.tableData', this.tableData);
      }
    },
    // 编辑或新增
    editAndAdd(record) {
      console.log('TCL: editAndAdd -> record', record);
      this.isVisibleBrand = true;
      if (!record.id) {
        // 新增
        this.title = '新增资料';
        this.brandId ='';
		 this.$refs.formRef.updateData(1);
        this.$nextTick(() => {
          this.$refs.formRef.$refs.basicForm.form.resetFields();
        });
		this.limit=false
		 this.editType=false
      } else {
		  this.limit=true
		  this.editType=true
        // 编辑
        this.brandId = record.id;
        this.companyIsDisabled=true;
        this.title = '编辑资料';
		this.$refs.formRef.reset();
		 this.$refs.formRef.updateData(record.scene);
        this.$nextTick(() => {
          let fileList=record.data.attach_doc_info_list.map((item)=>{
            return {
              name: item.name,
              uid: item.id,
              url: item.url,
            };
          });
          let data1 = {
            name: record.name,
            scene: record.scene,
			need_seconds:record.data.need_seconds,
            type: record.data.type,
			      product_id:record.data.product_id,
            attach_doc_ids: fileList,
            summary: record.summary,
          };
          let data2={
            company_id: record.data.company_id,
            name: record.name,
            scene: record.scene,
			need_seconds:record.data.need_seconds,
            type: record.data.type,
            attach_doc_ids: fileList,
            summary: record.summary,
			      product_id:record.data.product_id,
          };
          let data=this.$store.state.user.role === 1?data2:data1;
          console.log(data);
          this.$refs.formRef.$refs.basicForm.form.setFieldsValue(data);
        });
      }
    },
    // 确定编辑或新增
    onSubmit() {
      this.$refs.formRef.$refs.basicForm.form.validateFields(
        async(err, values) => {
          console.log('TCL: onSubmit -> values', values);
          if (!err) {
            this.btnIsLoading=true;
            values.attach_doc_ids=values.attach_doc_ids.map((item)=>item.response?item.response.data.id:item.uid).join();
            let result = await this.$http.post('/AcademicMaterial/update', {
              ...values,
              id: this.brandId ? this.brandId : '',
			        cooperation_company_id: this.company_id
            });
            this.btnIsLoading=false;
            if (result.data.status === 1) {
              this.$message.success('操作成功！');
              this.isVisibleBrand = false;
              this.getTableData({ page: this.current, pageSize: this.pageSize,cooperation_company_id: this.company_id });
            }
            console.log('TCL: onSubmit -> values', values);
          }
        },
      );
    },
    // 取消编辑或新增
    onCancel() {
      this.isVisibleBrand = false;
    },
    // 禁用 启用
    async onConfirm(record) {
      let result=await this.$http.post('/AcademicMaterial/setStatus', {id: record.id, status: record.status===1?0:1});
      if(result.data.status===1){
        this.$message.success('操作成功！');
        this.getTableData({ page: this.current, pageSize: this.pageSize ,cooperation_company_id: this.company_id});
      }
    },
    // 删除
    async onDelete(record) {
      let result=await this.$http.post('/AcademicMaterial/setStatus', {id: record.id, status: -1});
      if(result.data.status===1){
        this.$message.success('操作成功！');
        this.getTableData({ page: this.current, pageSize: this.pageSize ,cooperation_company_id: this.company_id});
      }
    },
	onChangecompany(value) {
	  this.current=1;
	  this.company_id=value;
	  this.getTableData({page: this.current, pageSize: this.pageSize, type: this.typeId? this.typeId:undefined, keyword: this.keyword,cooperation_company_id: this.company_id});
	},
    // 分页
    changePage(pagination) {
      this.current=pagination.current;
      this.getTableData({
        page: pagination.current,
        pageSize: pagination.pageSize,
		cooperation_company_id: this.company_id
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.client-container {
  .ant-btn-round {
    font-size: 12px;
    height: 30px;
    padding: 0 17px;
    border-radius: 15px;
  }
}
/deep/.ant-select-selection--single{
  border-radius: 15px;
}
</style>
